import { urlEscaped } from '@app/utils/urlEscaped'

import { createApiAction } from '@app/packages/api/utils'
import type { ApiGiftCard, ApiGiftCardType } from '@app/packages/api/v2/types/entities'

export const getGiftCardsTypes = () =>
  createApiAction('getGiftCardsTypes', dispatch =>
    dispatch<{ data: ApiGiftCardType[]; included?: ApiGiftCardType[] }>({ method: 'GET', endpoint: '/api/v2/gift_cards/types' })
  )

export const postGiftCards = (params: { type_id: number; email: string }) =>
  createApiAction('postGiftCards', dispatch =>
    dispatch<{ data: ApiGiftCard }>({ method: 'POST', endpoint: '/api/v2/gift_cards', body: JSON.stringify(params) })
  )

export const getGiftCardsById = (uuid: string) =>
  createApiAction('getGiftCardsById', dispatch =>
    dispatch<{ data: ApiGiftCard; included?: ApiGiftCardType[] }>({ method: 'GET', endpoint: urlEscaped`/api/v2/gift_cards/${uuid}` })
  )
